<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    
  
<g transform="matrix(2,0,0,2,0,0)">
<path d="M23.71,11.29l-11-11a1,1,0,0,0-1.42,0l-11,11a1,1,0,0,0-.21,1.09A1,1,0,0,0,1,13H2.25a.25.25,0,0,1,.25.25V23a1,1,0,0,0,1,1H9.25a.25.25,0,0,0,.25-.25V19a2.5,2.5,0,0,1,5,0v4.75a.25.25,0,0,0,.25.25H20.5a1,1,0,0,0,1-1V13.25a.25.25,0,0,1,.25-.25H23a1,1,0,0,0,.92-.62A1,1,0,0,0,23.71,11.29Z">
</path></g>
  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    name: {
      type: String,
      required: false,
      default: 'Home',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 48 48',
    },
  },
};
</script>

<style scoped>
  
</style>